import Swiper from 'swiper'

export function initProductPyramidSwiper() {
  window.ps = new Swiper('.js-product-pyramid-swiper', {
    spaceBetween: 30,
    direction: 'horizontal',
    slidesPerView: 1,
    navigation: {
      prevEl: '.js-product-pyramid-swiper-arrow-prev',
      nextEl: '.js-product-pyramid-swiper-arrow-next',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  })
}
